export default __webpack_public_path__ + "static/media/homevilla4.3aea7848.jpg";